import {UIGameCanvasController} from './UIGameCanvasController'
import {UIGameManager} from './UIGameManager'

export abstract class UIGameLayout {
    protected readonly canvas: UIGameCanvasController
    protected readonly uiGameManager: UIGameManager

    constructor(uiGameManager: UIGameManager) {
        this.uiGameManager = uiGameManager
        this.canvas = this.uiGameManager.canvasController
    }

    abstract getHelpSectionY(): number

    abstract getHelpSectionHeight(): number

    abstract getStateControllerHeight(): number

    abstract getStateControllerY(): number

    abstract getPlayersControllerHeight(): number

    abstract getPlayersControllerChildOffset(): number

    abstract getEmbargoControllerY(): number

    getReplayViewHeight(): number {
        if(this.uiGameManager.replayView == undefined) return 0

        return this.uiGameManager.replayView.mainBlock.clientHeight
    }
}
